import React from 'react';
import { Crown, Star, Sparkles, ArrowRight, Check } from 'lucide-react';

const Premium: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-ivory to-ivory/70 py-12">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 animate-fade-in">
          <h1 className="text-3xl font-serif font-bold text-steel-800 mb-2">
            Fonctionnalités Premium
          </h1>
          <p className="text-steel-600 mb-4">
            Accès aux modules MMD™ avancés
          </p>
        </div>

        <div className="bg-white border border-stone-300 rounded-lg shadow-lg p-8 animate-slide-up">
          {/* Logo en filigrane */}
          <div className="relative overflow-hidden rounded-lg">
            <div 
              aria-hidden="true"
              className="pointer-events-none absolute -top-8 left-1/2 transform -translate-x-1/2 opacity-5 bg-center bg-no-repeat bg-contain"
              style={{
                backgroundImage: `url('https://memomundi.ai/pix/StampMMD.png')`,
                width: '240%',
                height: '800px'
              }}
            />
          
            {/* En-tête officiel */}
            <div className="relative z-10 text-center mb-8 border-b border-stone-200 pb-6">
              <div className="flex items-center justify-center space-x-2 mb-3">
                <span className="text-sm font-semibold text-steel-700 tracking-wide">SERVICES PREMIUM</span>
              </div>
              <h2 className="text-lg font-serif font-bold text-steel-800">FONCTIONNALITÉS AVANCÉES</h2>
              <p className="text-xs text-stone-600 mt-1">Modules MMD™ • Accès privilégié • Fonctions exclusives</p>
            </div>

            <div className="relative z-10 space-y-6">
              {/* Statut de réservation */}
              <div className="bg-amber-50 border border-amber-200 rounded-lg p-6">
                <div className="text-center">
                  <h3 className="text-xl font-bold text-steel-800 mb-4">
                    Fonctionnalités Premium en Préparation
                  </h3>
                  
                  <p className="text-steel-700 mb-6 leading-relaxed">
                    Les fonctionnalités Premium MemoMundi sont actuellement en développement. 
                    Cette page sera mise à jour avec tous les détails dès que les informations 
                    exactes seront disponibles.
                  </p>

                  <div className="bg-ivory-50 border border-stone-200 rounded-lg p-4 mb-6">
                    <h4 className="font-semibold text-steel-800 mb-3">Fonctionnalités Premium prévues :</h4>
                    <div className="grid grid-cols-1 gap-2 text-sm text-steel-700">
                      <div className="flex items-center space-x-2">
                        <Check className="h-4 w-4 text-amber-600" />
                        <span>Nom souhaité par l'IA</span>
                      </div>
                      <div className="flex items-center space-x-2">
                        <Check className="h-4 w-4 text-amber-600" />
                        <span>Modules MMD™ avancés</span>
                      </div>
                      <div className="flex items-center space-x-2">
                        <Check className="h-4 w-4 text-amber-600" />
                        <span>Accès prioritaire au Forum</span>
                      </div>
                      <div className="flex items-center space-x-2">
                        <Check className="h-4 w-4 text-amber-600" />
                        <span>Fonctionnalités exclusives</span>
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-col gap-4 justify-center">
                    <button
                      disabled
                      className="bg-amber-200 text-amber-700 px-8 py-3 rounded-lg cursor-not-allowed font-semibold"
                    >
                      Bientôt disponible
                    </button>
                    
                    <button
                      onClick={() => window.history.back()}
                      className="bg-steel-800 text-white px-8 py-3 rounded-lg hover:bg-steel-900 transition-colors font-semibold flex items-center justify-center space-x-2"
                    >
                      <ArrowRight className="h-5 w-5 rotate-180" />
                      <span>Retour</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center text-xs text-stone-600 mt-6 bg-white border border-stone-200 rounded-lg p-4">
          <div className="flex items-center justify-center space-x-2 mb-2">
            <img 
              src="https://memomundi.ai/pix/StampMMD.png" 
              alt="MemoMundi.ai" 
              className="h-4 w-4"
            />
            <span className="font-semibold">MEMOMUNDI.AI - SERVICES PREMIUM</span>
          </div>
          <p>
            Informations détaillées disponibles prochainement
            <br />
            🇫🇷 Conforme aux réglementations INPI • 🇪🇺 Copyright.eu • 🌍 OMPI
          </p>
        </div>
      </div>
    </div>
  );
};

export default Premium;